const { REACT_APP_MODE } = process.env;

const configs = {
  dev: {
    DEV: true,
    MAP_KEY: 'AIzaSyAos1-TiZ_uoQOicbFMFYTwTqUpY0h7umc',
    API_URL: 'http://192.168.31.145:3000',
    // API_URL: 'https://portal-api.sortpak.com',
    // API_URL: 'https://portal-preprod-api.sortpak.com',
  },
  prod: {
    PROD: true,
    MAP_KEY: 'AIzaSyAos1-TiZ_uoQOicbFMFYTwTqUpY0h7umc',
    API_URL: 'https://portal-api.sortpak.com',
    // API_URL: 'https://portal-preprod-api.sortpak.com',
  },
};

export default configs[REACT_APP_MODE] || configs.prod;
